import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const permissionsApi = createApi({
	reducerPath: "permissionsApi",
	keepUnusedDataFor: 0,
	baseQuery: fetchBaseQuery({
		// baseUrl: `${process.env.REACT_APP_SERVER_URL}`,
		prepareHeaders: (headers, { getState }) => {
			const token = getState().auth.token;
			if (token) {
				headers.set("authorization", `Bearer ${token}`);
			}
			return headers;
		},
	}),

	endpoints: (builder) => ({
		getSettings: builder.query({
			query: () => ({
				url: `${process.env.REACT_APP_SERVER_URL}api/permissions/get-settings`,
				method: "POST",
			}),
			transformResponse: (response) => response,
		}),
	}),
});

export const { useGetSettingsQuery } = permissionsApi;
